import { IAppState } from '../../common/state';
import { configSelector } from '../configSelector';
import { isInRegionSelector } from '../isInRegion';

export function selectIsNewbuildingConsultBannerAvailable(state: IAppState) {
  const config = configSelector(state);
  const consultantPhoneEnabledRegions = config.get<number[]>('newbuildingConsultant.phone.enabledRegions') || [];
  const availableInRegion = isInRegionSelector(consultantPhoneEnabledRegions)(state);

  return (
    state.isNewbuildingsOnly &&
    availableInRegion &&
    state.newbuildingConsultant.bannerAvailable &&
    !!config.get<boolean>('webim.accountName')
  );
}
